module.exports = __webpack_public_path__ + "img/kaifa02.5c9211ad.jpg";